import { FC } from "react";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import { agentCanBeAssignedToTickets } from "helpers/agent";
import { IAgent } from "store/entities/agents";
import { withVar } from "themes/helpers";

interface IProps {
  agent: IAgent;
}

export const AutoassignmentStatus: FC<IProps> = ({ agent }) => {
  const isAutoassignmentEnabled = agent.autoassignment;
  const canBeAutoassigned = agentCanBeAssignedToTickets(agent);

  const content = canBeAutoassigned ? (
    isAutoassignmentEnabled ? (
      <>Accepting</>
    ) : (
      <>Not accepting</>
    )
  ) : (
    <>Can&apos;t be auto-assigned</>
  );

  return (
    <Text customColor={withVar(DesignToken.ContentBasicSecondary)} size="sm">
      {content}
    </Text>
  );
};
